import apiClient from '@u/apiClient'
import GetAutomationListController from '@/wayfinder/actions/App/Http/Controllers/Automation/GetAutomationListController'
import GetAutomationModelConfigController from '@/wayfinder/actions/App/Http/Controllers/Automation/GetAutomationModelConfigController'
import UpdateAutomationModelConfigController from '@/wayfinder/actions/App/Http/Controllers/Automation/UpdateAutomationModelConfigController'
import GetAutomationByIdController from '@/wayfinder/actions/App/Http/Controllers/Automation/GetAutomationByIdController'
import CreateAutomationController from '@/wayfinder/actions/App/Http/Controllers/Automation/CreateAutomationController'
import UpdateAutomationController from '@/wayfinder/actions/App/Http/Controllers/Automation/UpdateAutomationController'
import DuplicateAutomationController from '@/wayfinder/actions/App/Http/Controllers/Automation/DuplicateAutomationController'
import UpdateAutomationStatusController from '@/wayfinder/actions/App/Http/Controllers/Automation/UpdateAutomationStatusController'
import DeleteAutomationController from '@/wayfinder/actions/App/Http/Controllers/Automation/DeleteAutomationController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    if ('new_id' in payload) {
      payload.successCallback(payload.new_id)
    } else {
      payload.successCallback()
    }
  }
}

export default {
  // region fetch

  fetchAutomationList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAutomationListController.get(), {
          params: { model: payload.model }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchModelConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAutomationModelConfigController.get(), {
          params: {
            model_id: payload.model_id,
            model_type: payload.model_type
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateModelConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateAutomationModelConfigController.put(), {
          model_id: payload.model_id,
          model_type: payload.model_type,
          automation_id: payload.automation_id,
          event: payload.event
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewAutomation({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'automation' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchAutomationById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAutomationByIdController.get({ automation: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeNewAutomation({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateAutomationController.post(), payload.automation)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateAutomation({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAutomationController.put({ automation: payload.id }),
          payload.automation
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  duplicateAutomationById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DuplicateAutomationController.put({ automation: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateAutomationStatus({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAutomationStatusController.put({ automation: payload.id }),
          {
            active: payload.active
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deleteAutomationById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAutomationController.delete.delete({ automation: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteAutomationById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteAutomationController.undo.get({ id: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
